import * as React from 'react'
import * as Sentry from '@sentry/browser'
import { Button, Callout, Classes, Dialog, H5, Intent } from '@blueprintjs/core'
import Client from '../../../client'
import { getErrorString } from '../../../utils/serverErrorUtils'
import { pluralize } from '../../../utils/string'

export interface Props {
  onClose: (shouldShowSuccess) => void
  isOpen: boolean
  productIds: number[] // an array of product IDs
}

export const BulkRemoveProductAttributeOverrideDialog: React.FC<Props> = props => {
  const { productIds } = props
  const [error, setError] = React.useState(null)
  const [loading, setLoading] = React.useState(false)

  const removeProductsAttributeOverride = async () => {
    setLoading(true)
    setError(null)
    try {
      await Client.removeProductAttributeOverrides(productIds)
      props.onClose(true)
    } catch (err) {
      const message = getErrorString(err, Sentry.captureException)
      setError(message)
    } finally {
      setLoading(false)
    }
  }

  return (
    <Dialog title="End Price Override" isOpen={props.isOpen} onClose={() => props.onClose(false)}>
      <div className={Classes.DIALOG_BODY}>
        {error && <Callout intent={Intent.DANGER}>{error}</Callout>}
        <H5>
          Are you sure you want to end the price override for {productIds.length} product{pluralize(productIds)}?
        </H5>
        <p>
          The products will be reverted back to the previous price, compare at price prior to the price override. Added
          tags will be removed.
        </p>
      </div>
      <div className={Classes.DIALOG_FOOTER}>
        <div className={Classes.DIALOG_FOOTER_ACTIONS}>
          <Button intent={Intent.PRIMARY} onClick={removeProductsAttributeOverride} loading={loading}>
            End price override ({productIds.length})
          </Button>
        </div>
      </div>
    </Dialog>
  )
}
